import styled from 'styled-components';

export const SidebarIcon = styled.span<{ disabled?: boolean }>`
	font-size: 1.2rem;
	color: ${({ disabled }) => (disabled ? '#999' : '#fff')};
	cursor: ${({ disabled }) => (disabled ? 'pointer' : 'not-allowed')};
	display: inline-block;
	margin-top: -3px;
`;
